module.exports = __webpack_public_path__ + "img/17.c1c9a8cc.jpg";